import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';
import BrowserUtils from '../../utils/BrowserUtils';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import UserManagementStore from '../../stores/UserManagementStore';

class PayeeAccountCardInfo extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.delete = this.delete.bind(this);
    this.editClick = this.editClick.bind(this);
    this.payeeNumber = this.payeeNumber.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);

    this.state = {
      isNominatedUser: UserManagementStore.isNominatedUser(),
    };
  }

  onClick(e) {
    if (e.target.localName !== 'button') {
      MoveMoneyStore.resetSavingsPotToClicked(false);
      this.props.onClick(this.props.data);
    }
  }

  checkKeyPress(e) {
    if (e.which === 40 || e.keyCode === 40) {
      if (document.activeElement.nextSibling) {
        document.activeElement.nextSibling.focus();
      }
    } else if (e.which === 38 || e.keyCode === 38) {
      if (document.activeElement.previousSibling) {
        document.activeElement.previousSibling.focus();
      }
    }
    if (e.which === 13 || e.keyCode === 13) {
      this.onClick(e);
      if (e.target.tagName !== 'BUTTON') {
        e.preventDefault();
      }
    }
  }

  delete(e) {
    if (e.target.localName === 'button' && e.target.innerHTML === 'Delete') {
      this.props.delete(this.props.data);
    }
  }

  editClick(e) {
    if (e.target.localName === 'button' && e.target.innerHTML === 'Edit') {
      MoveMoneyPayeeActionCreator.savePayeeInStore(this.props.data);
      this.props.editClick(this.props.data);
    }
  }

  payeeNumber() {
    const accountNumber = this.props.data.to_account.account_number;
    const sortcode = NumberUtils.formatSortCode(
      this.props.data.to_account.sort_code
    );
    return (
      <div>
        <span>
          <span className="u-visually-hidden off-screen">
            Payee account Sort Code
          </span>
          {`${sortcode} | `}
        </span>
        <span>
          <span className="u-visually-hidden off-screen">
            Payee account number
          </span>
          {accountNumber}
        </span>
      </div>
    );
  }

  render() {
    const { isNominatedUser } = this.state;
    const activeNomineeClass = isNominatedUser
      ? ' account-card__payeename--nominated'
      : '';

    return !BrowserUtils.isMobileView() ? (
      this.props.data.hasOwnProperty('display_name') &&
      this.props.data.display_name !== '' ? (
        <li
          role="option"
          className="account-card account-card--payee"
          tabIndex="0"
          onClick={this.onClick}
          onKeyDown={this.checkKeyPress}
        >
          <dl className="account-card__data">
            <dt className="account-card__data__name">Payee nickname</dt>
            <dd
              className={`account-card__payeename${activeNomineeClass}`}
              id={this.props.data.id}
            >
              {this.props.data.display_name}
            </dd>
            {!isNominatedUser && (
              <dt className="account-card__data__name">Payee options</dt>
            )}
            {!isNominatedUser && (
              <dd className="account-card__options pull-right">
                <button
                  className="c-btn c-btn--link"
                  onClick={this.editClick}
                  id="edit1"
                  aria-label={`edit ${this.props.data.display_name}`}
                >
                  Edit
                </button>
                <button
                  className="c-btn c-btn--link"
                  onTouchStart={this.delete}
                  onClick={this.delete}
                  aria-haspopup="true"
                  id="delete1"
                  aria-label={`delete ${this.props.data.display_name}`}
                >
                  Delete
                </button>
              </dd>
            )}
            <dt className="account-card__data__name" />
            <dd className="account-card__number">{this.payeeNumber()}</dd>

            <dt className="account-card__data__name">Payee reference</dt>
            <dd className="account-card__reference">
              {this.props.data.reference}
            </dd>
          </dl>
        </li>
      ) : (
        <li
          role="option"
          className="account-card account-card--payee"
          tabIndex="0"
          onClick={this.onClick}
          onKeyDown={this.checkKeyPress}
        >
          <dl className="account-card__data">
            <dt className="account-card__data__name">Payee nickname</dt>

            <dd
              className={`account-card__payeename${activeNomineeClass}`}
              id={this.props.data.id}
            >
              {this.props.data.to_account.name}
            </dd>

            <span className="u-visually-hidden" id="payeeEdit">
              Edit
            </span>
            <span className="u-visually-hidden" id="payeeDelete">
              Delete
            </span>
            {!isNominatedUser && (
              <dt className="account-card__data__name">Payee options</dt>
            )}
            {!isNominatedUser && (
              <dd className="account-card__options pull-right">
                <button
                  className="c-btn c-btn--link"
                  onClick={this.editClick}
                  id="edit2"
                  aria-label={`edit ${this.props.data.display_name}`}
                >
                  Edit
                </button>
                <button
                  className="c-btn c-btn--link"
                  onTouchStart={this.delete}
                  onClick={this.delete}
                  aria-haspopup="true"
                  id="delete2"
                  aria-label={`delete ${this.props.data.display_name}`}
                >
                  Delete
                </button>
              </dd>
            )}
            <dt className="account-card__data__name" />
            <dd className="account-card__number">{this.payeeNumber()}</dd>

            <dt className="account-card__data__name">Payee reference</dt>
            <dd className="account-card__reference">
              {this.props.data.reference}
            </dd>
          </dl>
        </li>
      )
    ) : this.props.data.hasOwnProperty('display_name') &&
      this.props.data.display_name !== '' ? (
      <li
        role="option"
        className="account-card account-card--payee"
        tabIndex="0"
        onClick={this.onClick}
        onKeyDown={this.checkKeyPress}
      >
        <dl className="account-card__data">
          <dt className="account-card__data__name">Payee nickname</dt>

          <dd
            className={`account-card__payeename${activeNomineeClass}`}
            id={this.props.data.id}
          >
            {this.props.data.display_name}
          </dd>

          <span className="u-visually-hidden" id="payeeEdit">
            Edit
          </span>
          <span className="u-visually-hidden" id="payeeDelete">
            Delete
          </span>
          {!isNominatedUser && (
            <dt className="account-card__data__name">Payee options</dt>
          )}
          {!isNominatedUser && (
            <dd className="account-card__options pull-right">
              <button
                className="c-btn c-btn--link"
                onClick={this.editClick}
                id="edit3"
                aria-label={`edit ${this.props.data.display_name}`}
              >
                Edit
              </button>
              <button
                className="c-btn c-btn--link"
                onTouchStart={this.delete}
                onClick={this.delete}
                aria-haspopup="true"
                id="delete3"
                aria-label={`delete ${this.props.data.display_name}`}
              >
                Delete
              </button>
            </dd>
          )}
          <dt className="account-card__data__name" />
          <dd className="account-card__number">{this.payeeNumber()}</dd>

          <dt className="account-card__data__name">Payee reference</dt>
          <dd className="account-card__reference">
            {this.props.data.reference}
          </dd>
        </dl>
      </li>
    ) : (
      <li
        role="option"
        className="account-card account-card--payee"
        tabIndex="0"
        onClick={this.onClick}
        onKeyDown={this.checkKeyPress}
      >
        <dl className="account-card__data">
          <dt className="account-card__data__name">Payee nickname</dt>

          <dd
            className={`account-card__payeename${activeNomineeClass}`}
            id={this.props.data.id}
          >
            {this.props.data.to_account.name}
          </dd>

          <span className="u-visually-hidden" id="payeeEdit">
            Edit
          </span>
          <span className="u-visually-hidden" id="payeeDelete">
            Delete
          </span>
          {!isNominatedUser && (
            <dt className="account-card__data__name">Payee options</dt>
          )}
          {!isNominatedUser && (
            <dd className="account-card__options pull-right">
              <button
                className="c-btn c-btn--link"
                onClick={this.editClick}
                id="edit4"
                aria-label={`edit ${this.props.data.display_name}`}
              >
                Edit
              </button>
              <button
                className="c-btn c-btn--link"
                onTouchStart={this.delete}
                onClick={this.delete}
                aria-haspopup="true"
                id="delete4"
                aria-label={`delete ${this.props.data.display_name}`}
              >
                Delete
              </button>
            </dd>
          )}
          <dt className="account-card__data__name" />
          <dd className="account-card__number">{this.payeeNumber()}</dd>

          <dt className="account-card__data__name">Payee reference</dt>
          <dd className="account-card__reference">
            {this.props.data.reference}
          </dd>
        </dl>
      </li>
    );
  }
}

PayeeAccountCardInfo.propTypes = {
  data: PropTypes.object,
};

PayeeAccountCardInfo.defaultProps = {
  data: {},
};

export default PayeeAccountCardInfo;
